import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "../../common/network-call";
import { INSTANCE_URL, itemCount } from "../../common/constant";

export const SPECIFICATION_LIST = "SPECIFICATION_LIST";
export const VEHICLE_LIST = "VEHICLE_LIST";
export const EDIT_NUMBERPLATE = "EDIT_NUMBERPLATE";
export const LOCATION_LIST = "LOCATION_LIST";
export const SERVICE_LIST = "SERVICE_LIST";

export function fetchLocation(session, companyid, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/service_location?filter=((useridfk=${companyid})AND(isactive=1))`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: LOCATION_LIST,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchService(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/service`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: SERVICE_LIST,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchSpecification(session, companyid, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;

  var body = {
    companyid: companyid,
    type: "company_program",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: SPECIFICATION_LIST,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function validateNumberPlateEdit(
  session,
  numberplate,
  vehicleid,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicles?filter=((numberplate=${numberplate})AND(vehicleid!=${vehicleid}))`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2 });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function validateNumberPlate(session, numberplate, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicles?filter=(numberplate=${numberplate})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2 });
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addVehicle(
  session,
  values,
  carwashcompanyid,
  locationid,
  callback
) {
  var urlVehicle = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicles`;
  var urlProgram = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicle_program`;
  var body = {
    resource: [
      {
        ...values,
      },
    ],
  };
  //console.log("body: -", body);
  return (dispatch) => {
    postRequest(
      urlVehicle,
      body,
      session,
      dispatch,
      (response) => {
        //console.log("location response: -", response);
        if (
          response.resource &&
          response.resource.length > 0 &&
          response.resource[0].vehicleid
        ) {
          let data = {};
          data.vehicleid = response.resource[0].vehicleid;
          data.numberplate = values.numberplate;
          data.carwashcompanyid = carwashcompanyid;
          data.programid = values.programid;
          data.carwashlocationid = locationid;
          var programBody = {
            resource: [
              {
                ...data,
              },
            ],
          };

          postRequest(
            urlProgram,
            programBody,
            session,
            dispatch,
            (responseDevice) => {
              callback({ success: 1 });
            },
            (error) => {
              //callback({ success: 0, message: error });
            }
          );
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchVehicleList(session, companyid, pageCount = 0, callback) {
  // console.log("companyid", companyid);
  // debugger;
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;

  var body = {
    companyid: companyid,
    type: "company_vehicle",
    isbadge: 0,
    offset: offset,
    limit: perPage,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: VEHICLE_LIST,
          payload: { data: response.result, count: response.count },
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };

  // var url = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicles?caller=web&related=device_usage_cost_by_company_vehicle_program&filter=((hruserid=${session.userid})AND(isbadge=0))&include_count=true&order=vehicleid%20DESC${offSetQuery}`;
  // return (dispatch) => {
  //   getRequest(
  //     url,
  //     session,
  //     dispatch,
  //     (response) => {
  //       dispatch({
  //         type: VEHICLE_LIST,
  //         payload: { data: response.resource, count: response.meta.count },
  //       });
  //       callback({ success: 1 });
  //     },
  //     (error) => {
  //       // callback({success: 0, error: error});
  //     }
  //   );
  // };
}

export function activateDeactivate(session, values, vehicleid, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/company_vehicles/${vehicleid}`;

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
export function deleteNumberplate(session, vehicleid, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/company_vehicles/${vehicleid}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function setNumberplate(obj) {
  return { type: EDIT_NUMBERPLATE, payload: obj };
}

export function updateVehicle(
  session,
  values,
  carwashcompanyid,
  locationid,
  callback
) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/company_vehicles/${values.vehicleid}`;
  var delurl = `${INSTANCE_URL}api/v2/tikwash/_table/company_vehicle_program?filter=(vehicleid=${values.vehicleid})`;
  var geturl = `${INSTANCE_URL}api/v2/tikwash/_table/company_vehicle_program?filter=((vehicleid=${values.vehicleid})AND(carwashcompanyid=${carwashcompanyid}))`;
  var urlProgram = `${INSTANCE_URL}/api/v2/tikwash/_table/company_vehicle_program`;

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        getRequest(
          geturl,
          session,
          dispatch,
          (data) => {
            if (data.resource.length > 0 && data.resource[0].id) {
              // update
              let patchData = {};

              patchData.programid =
                values.programid == "null" || values.programid == undefined
                  ? null
                  : values.programid;

              patchRequest(
                urlProgram + "/" + data.resource[0].id,
                patchData,
                session,
                dispatch,
                (response1) => {
                  callback({ success: 1 });
                },
                (error) => {
                  callback({ success: 0, message: error });
                }
              );
            } else {
              //insert

              let data = {};
              data.vehicleid = values.vehicleid;
              data.numberplate = values.numberplate;
              data.carwashcompanyid = carwashcompanyid;
              data.programid =
                values.programid == "null" || values.programid == undefined
                  ? null
                  : values.programid;
              data.carwashlocationid = locationid;
              var programBody = {
                resource: [
                  {
                    ...data,
                  },
                ],
              };

              postRequest(
                urlProgram,
                programBody,
                session,
                dispatch,
                (responseDevice) => {
                  callback({ success: 1 });
                },
                (error) => {
                  //callback({ success: 0, message: error });
                }
              );
            }
          },
          (error) => {
            callback({ success: 0, message: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
